import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Button from './Button';
import ModalEnum from '../../shared/enums/modalEnum.js';

class GlobalModal extends React.Component {
    render() {
        return (
            <Modal
                fade={false}
                isOpen={this.props.isOpen}
                className="modal-info"
            >
                <ModalHeader>{this.props.type}</ModalHeader>
                <ModalBody>
                    {this.props.content.html == null &&
                        <div>{this.props.content.text}</div>}
                    {this.props.content.html != null &&
                        <div
                            className="info-modal-class"
                            dangerouslySetInnerHTML={{ __html: this.props.content.text }}
                        />
                    }
                </ModalBody>
                <ModalFooter>
                    <div
                        className="button-items"
                        style={{ margin: '0 auto' }}
                    >
                        {this.props.type === ModalEnum.Confirmation &&
                            <ul>
                                <li>
                                    <Button onClick={this.props.accept} text={"Yes"} />
                                </li>
                                <li>
                                    <Button onClick={this.props.decline} text={"No"} />
                                </li>
                            </ul>}
                        {this.props.type === ModalEnum.Information &&
                            <ul>
                                <li>
                                    <Button onClick={this.props.close} text={"OK"} />
                                </li>
                            </ul>}
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default (GlobalModal);